"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToCartActionView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DropdownListView = require("./DropdownListView");
var _wbmInputs = require("wbm-inputs");
var _index = require("../../index");
var _AddFavorite = require("./AddFavorite");
var _inlineAlertSuccess = require("../../components/inlineAlertSuccess/inlineAlertSuccess");
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _DeleteOutlined = _interopRequireDefault(require("@material-ui/icons/DeleteOutlined"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _ErrorOutline = _interopRequireDefault(require("@material-ui/icons/ErrorOutline"));
var _SuccessAlert = require("../SuccessAlert");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AddToCartActionView = exports.AddToCartActionView = function AddToCartActionView(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = (0, _react.useState)({
      val: props.list[0].value,
      text: props.list[0].text
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dropVals = _useState2[0],
    storeDropVals = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    displayToastError = _useState6[0],
    setDisplayToastError = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    addToCartClicked = _useState8[0],
    setAddToCartClicked = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    deleteSelected = _useState10[0],
    setDeleteSelected = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = _slicedToArray(_useState11, 2),
    tooltipTimeoutId = _useState12[0],
    setTooltipTimeoutId = _useState12[1];
  var qtyMsgClass = {
    marginRight: '5px',
    height: '20px',
    width: '20px',
    alignSelf: "flex-start"
  };
  var qtyElement = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    style: qtyMsgClass
  }), /*#__PURE__*/_react["default"].createElement("span", null, "Added"));
  if (props.quantityMessage) {
    var qtyMsg1 = props.quantityMessage.split('.')[0];
    var qtyMsg2 = props.quantityMessage.split('.')[1];
    qtyElement = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ErrorOutline["default"], {
      style: qtyMsgClass
    }), /*#__PURE__*/_react["default"].createElement("span", null, qtyMsg1, ".", /*#__PURE__*/_react["default"].createElement("b", null, qtyMsg2, ".")));
  }
  var setValsToSave = function setValsToSave(selectedValue, selectedText) {
    storeDropVals({
      val: selectedValue,
      text: selectedText
    });
    props.itemSelected && props.itemSelected(selectedValue, selectedText);
  };
  var sendStoreValues = function sendStoreValues(event) {
    event.stopPropagation();
    if (props.AddItemSelected) {
      setLoading(true);
      setAddToCartClicked(true);
      props.AddItemSelected(dropVals.val, dropVals.text);
    }
  };
  (0, _react.useEffect)(function () {
    if (addToCartClicked && props.addedToCart !== undefined && props.addedToCart.length > 0 && props.itemIdentifier && !props.isAddToCartActive) {
      var _props$addedToCart;
      if ((_props$addedToCart = props.addedToCart) !== null && _props$addedToCart !== void 0 && _props$addedToCart.some(function (x) {
        var _props$itemIdentifier, _props$itemIdentifier2;
        return x.itemIdentifier.id === ((_props$itemIdentifier = props.itemIdentifier) === null || _props$itemIdentifier === void 0 ? void 0 : _props$itemIdentifier.id) && x.itemIdentifier.unitId === ((_props$itemIdentifier2 = props.itemIdentifier) === null || _props$itemIdentifier2 === void 0 ? void 0 : _props$itemIdentifier2.unitId);
      })) {
        setAddToCartClicked(false);
        setLoading(false);
        if (props.slideInfo) {
          setTooltipTimeoutId(0);
        } else {
          if (tooltipTimeoutId > 0) {
            clearTimeout(tooltipTimeoutId);
          }
          var timeoutId = setTimeout(function () {
            setTooltipTimeoutId(0);
          }, 3500);
          setTooltipTimeoutId(timeoutId);
        }
      } else {
        setLoading(false);
      }
    }
  }, [props.addedToCart, props.isAddToCartActive]);
  (0, _react.useEffect)(function () {
    if (props.error && props.error !== "") {
      setDisplayToastError(true);
      setLoading(false);
    }
  }, [props.error]);
  (0, _react.useEffect)(function () {
    if (props.doPreventAddToCart || !props.isAddToCartActive) {
      setLoading(false);
    }
  }, [props.doPreventAddToCart, props.isAddToCartActive]);
  function removeFavorites() {
    setDeleteSelected(true);
    props.removeFavorite();
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DropdownListView.DropdownListView, {
    list: props.list,
    itemSelected: setValsToSave,
    setLength: props.setLength,
    changeZIndex: props.changeZIndex,
    isSkuGroupSearch: props.isSkuGroupSearch,
    qtyOnBlur: props.qtyOnBlur,
    forceInput: props.forceInput,
    inputIdentifier: props.inputIdentifier,
    inputLabel: props.inputLabel
  }), props.added ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_inlineAlertSuccess.InlineAlertSuccess, {
    message: "ADDED"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  })) : /*#__PURE__*/_react["default"].createElement(_index.SelectedToolTip, {
    arrow: true,
    placement: "top",
    open: tooltipTimeoutId > 0,
    title: qtyElement
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "".concat(props.buttonClass).concat(props.favSelected ? " my-list" : ""),
    onClick: function onClick(event) {
      return sendStoreValues(event);
    },
    disabled: loading
  }, loading ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
  }) : props.buttonContent)), displayToastError && /*#__PURE__*/_react["default"].createElement(_SuccessAlert.SuccessAlert, {
    timerLengthInMS: 3500,
    danger: true,
    dangerText: "Please try again. If the problem persists, please call 1-888-WB-MASON.",
    dangerAttentionText: "An error has occurred!",
    onClickClose: function onClickClose() {
      return setDisplayToastError(false);
    },
    attentionText: '',
    text: ''
  }), props.addNote && /*#__PURE__*/_react["default"].createElement("div", {
    className: "add-note"
  }, /*#__PURE__*/_react["default"].createElement(_index.AddNoteModal, {
    charRemain: props.charRemain || 100,
    inputVal: props.inputVal,
    saveNote: props.saveNote,
    button: /*#__PURE__*/_react["default"].createElement(_index.AddNote, {
      tooltipText: props.tooltipText || '',
      onClick: props.addedNoteIcon,
      added: false
    })
  })), props.setFavorite && props.manageList && /*#__PURE__*/_react["default"].createElement("span", {
    className: "delete-icon"
  }, /*#__PURE__*/_react["default"].createElement(_index.SelectIcon, {
    selected: deleteSelected,
    onClick: function onClick() {
      return removeFavorites();
    },
    selectText: "Remove from List",
    icon: !deleteSelected ? /*#__PURE__*/_react["default"].createElement(_DeleteOutlined["default"], null) : /*#__PURE__*/_react["default"].createElement(_Delete["default"], null),
    color: "red"
  })), props.setFavorite && /*#__PURE__*/_react["default"].createElement(_AddFavorite.AddToCartFavorite, {
    favSelected: props.favSelected,
    setFavorite: function setFavorite() {
      return props.setFavorite();
    }
  }));
};
AddToCartActionView.defaultProps = {
  buttonClass: "col btn-primary",
  buttonContent: "Add To Cart"
};
//# sourceMappingURL=AddToCartActionView.js.map